// tyrant-throne.midokuni.com
import React from "react";
import { Image, Row } from "react-bootstrap";


export default function Dakicord2026Valentines() {
	return (<>
	<h3 className="text-pink">Dakimakura Discord Server - 2026 Valentine's Event!!</h3>
	<p>This was made for an event in the <a href="https://discord.gg/D4auNSpWyP">Dakimakuras Discord Server</a>.</p>
	<h4 className="text-pink">Collage into One File</h4>
	<p>The pillows are normally on the other side of the bed so I wake up seeing the Hinas. I just flipped them for the pic.</p>
	<Image src="/img/event/dakicord-2026-valentines/Collage.png" style={{maxHeight: "90vh", maxWidth: "95vw"}} />
	<Row>
		<h4 className="text-pink">Individual Images</h4>
		<p>If needed, I have the individual images available here as well.</p>
		<Image src="/img/event/dakicord-2026-valentines/shrine.jpg" style={{maxWidth: "90vw"}} />
		<Image src="/img/event/dakicord-2026-valentines/bed.jpg" style={{maxWidth: "90vw"}} />
		<Image src="/img/event/dakicord-2026-valentines/light.jpg" style={{maxWidth: "90vw"}} />
	</Row>
	</>);
}